import { logWrapper } from '../utils';

function dropZoneDirectiveFactory(runtimeConstant) {
  function link(scope, element) {
    element.on('dragover', (event) => {
      event.preventDefault();
    });

    element.on('drop', (event) => {
      event.preventDefault();

      const pageIndex = parseInt(element.attr('data-page'), 10);
      const canvas = document.getElementById(`pdf-canvas-${pageIndex}`);

      if (!canvas || isNaN(pageIndex)) {
          return;
      }

      const rect = canvas.getBoundingClientRect();

      const sealWidth = 190;
      const sealHeight = 52;

      let x = event.clientX - rect.left;
      let y = event.clientY - rect.top;

      if (
          x < 0 ||
          y < 0 ||
          x > rect.width ||
          y > rect.height
      ) {
          return;
      }

      x = Math.max(
          0,
          Math.min(x, rect.width - sealWidth)
      );

      y = Math.max(
          0,
          Math.min(y, rect.height - sealHeight)
      );
      scope.$apply(() => {
          scope.seal.length = 0;

          scope.seal.push({
              page: pageIndex,
              x: x,
              y: y,
              rectWidth: rect.width,
              rectHeight: rect.height
          });
      });
    });
  }

  function run() {
    return {
      restrict: 'A',
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const dropZoneDirective = ['runtimeConstant', dropZoneDirectiveFactory];
